<div class="compare-panes">

    <div class="compare-pane" *ngFor="let file of ResolvedFiles; let i = index">

        <span class="compare-pane-label" [title]="file.name">{{file.name}}</span>

        <ng-container [ngSwitch]="file.format">

            <ng-container *ngSwitchCase="'pdf'">

                <object [data]="file.url|security:'resourceUrl'" type="application/pdf" width="100%">
                    <source [src]="file.url|security:'resourceUrl'" type="application/pdf" />
                    <p>O seu navegador não suporta PDFs. <a [href]="file.url">Clique aqui para abrir.</a></p>
                </object>

            </ng-container>

            <ng-container *ngSwitchDefault>

                <div class="image-wrapper">
                    <img *ngIf="file.url" [src]="file.url"
                        [style.transform]="'translate(' + ViewerState[i].translateX + 'px,' + ViewerState[i].translateY + 'px) ' + 'scale(' + ViewerState[i].zoom + ') ' +  'rotate(' + ViewerState[i].rotation + 'deg)'"
                        (mousedown)="StartDrag(i, $event)" (mousemove)="OnDrag(i, $event)" (mouseup)="EndDrag(i)"
                        (mouseleave)="EndDrag(i)" (wheel)="OnWheel(i, $event)" />
                </div>

                <div class="pane-controls">

                    <ion-button fill="clear" (click)="ZoomOut(i)">
                        <ion-icon name="remove-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="ZoomIn(i)">
                        <ion-icon name="add-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="Rotate(i, -90)">
                        <ion-icon name="refresh-outline" slot="icon-only" style="transform: scaleX(-1)"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="Reset(i)">
                        <ion-icon name="contract-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="Rotate(i, 90)">
                        <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                </div>

            </ng-container>
        </ng-container>

        <ng-container *ngIf="Annotations[i] as a">

            <svg class="annotation-layer" [class.editing]="a.editing" (pointerdown)="OnAnnotateDown(i, $event)"
                (pointermove)="OnAnnotateMove(i, $event)" (pointerup)="OnAnnotateUp(i)"
                (pointercancel)="OnAnnotateUp(i)">
                <ng-container *ngFor="let item of a.items">
                    <path *ngIf="item.tool !== 'text'" [attr.d]="item.d" fill="none" stroke-linecap="round"
                        stroke-linejoin="round" [attr.stroke]="item.tool === 'strike' ? '#000' : '#e53935'"
                        [attr.stroke-width]="item.tool === 'strike' ? 16 : 3" />
                    <text *ngIf="item.tool === 'text'" [attr.x]="item.x" [attr.y]="item.y" fill="#e53935"
                        font-size="16" font-weight="600">{{item.text}}</text>
                </ng-container>
            </svg>

            <input *ngIf="a.draft" class="text-draft" [style.left.px]="a.draft.x" [style.top.px]="a.draft.y"
                [(ngModel)]="a.draft.value" (keydown.enter)="CommitDraft(i)" (keydown.escape)="a.draft = null"
                (blur)="CommitDraft(i)" />

            <div class="annotation-tools">

                <ng-container *ngIf="a.editing">

                    <ion-button fill="clear" [class.active]="a.tool === 'pen'" (click)="SetTool(i, 'pen')">
                        <ion-icon name="create-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" [class.active]="a.tool === 'strike'" (click)="SetTool(i, 'strike')">
                        <ion-icon name="brush-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" [class.active]="a.tool === 'text'" (click)="SetTool(i, 'text')">
                        <ion-icon name="text-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" [disabled]="!a.items.length" (click)="Undo(i)">
                        <ion-icon name="arrow-undo-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" [disabled]="!a.items.length" (click)="Clear(i)">
                        <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                </ng-container>

                <ion-button fill="clear" [class.active]="a.editing" (click)="ToggleEdit(i)">
                    <ion-icon [name]="a.editing ? 'close-outline' : 'pencil-outline'" slot="icon-only"></ion-icon>
                </ion-button>

            </div>

        </ng-container>

    </div>

</div>
